<div class="" *ngIf="this.type!='' && this.type=='IMAGE'">
  <div class="image-enlarger">
    <a (click)="enlargerOpen()">
      <div [ngClass]="'image-enlarger-overlay '+overlay_class_name">
        <span class="fa-stack fa-lg">
          <i class="fa fa-eye fa-stack-2x"></i>
        </span>
      </div>
      <img [src]="this.src" [width]="this.width" [height]="this.height" [class]="this.class_name"
        [alt]="this.alt_name" />
    </a>
  </div>
</div>


<div class="" *ngIf="this.type!='' && this.type=='LINK'">
  <a (click)="enlargerOpen()" [class]="this.link_class">{{this.link_name}} </a>
  <i [class]="link_icon"></i>
</div>

<div *ngIf="this.open" class="fullscreen-image-emlarger">
  <div class="image-enlarger-buttons-group">
    <button class="fullscreen-image-enlarger-buttons" (click)="this.operation(this.Operations_Label['ROTATERIGHT'])"
      [disabled]="this.rotation==this.operation_Values.MINROTATE">
      <i class="fa fa-undo"></i>
    </button>

    <button class="fullscreen-image-enlarger-buttons" (click)="this.operation(this.Operations_Label['ROTATELEFT'])"
      [disabled]="this.rotation==this.operation_Values.MAXROTATE">
      <i class="fa fa-repeat"></i>
    </button>

    <button class="fullscreen-image-enlarger-buttons" (click)="this.operation(this.Operations_Label['ZOOMIN'])"
      [disabled]="this.zoom_scale==this.operation_Values.MAXZOOM">
      <i class="fa fa-search-plus"></i>
    </button>

    <button class="fullscreen-image-enlarger-buttons" (click)="this.operation(this.Operations_Label['ZOOMOUT'])"
      [disabled]="this.zoom_scale==this.operation_Values.MINZOOM">
      <i class="fa fa-search-minus"></i>
    </button>
    <button class="fullscreen-image-enlarger-buttons" (click)="this.enlargerCloser()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <img [src]="this.src" [alt]="this.alt_name" class="fullscreen-image-emlarger-preview" id="image-enlarger-image" />
</div>